import React, { FunctionComponent, useContext, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../UserContext';
import { PageContext } from '../PageContext';
import { AppBar, AppBarSection, AppBarSpacer, Menu, MenuItem } from '@progress/kendo-react-layout';
import { Badge, BadgeContainer } from "@progress/kendo-react-indicators"
import { menuIcon } from '@progress/kendo-svg-icons';
import { Button, DropDownButton, SplitButton } from '@progress/kendo-react-buttons';
import { Input, InputChangeEvent } from '@progress/kendo-react-inputs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faUser, faQuestionCircle, faBell, faMagnifyingGlass, faForward, faFileCirclePlus, faTrash, faShare, faGlobe, faQuestion, faBullhorn, faList, faGear, faGears, faBars, faArrowRight, faArrowLeft, faAngleLeft, faCaretLeft} from '@fortawesome/free-solid-svg-icons';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import {Grid, GridColumn as Column, GridDataStateChangeEvent, GridSortChangeEvent, GridCustomCellProps, GridCellProps, GridCellsSettings} from '@progress/kendo-react-grid';
import { getSavedQueries, deleteUserQuery, getNextAd } from '../../services/apiService';
import parse from 'html-react-parser';
import { ButtonGroup } from 'reactstrap';
import { Notification } from '@progress/kendo-react-notification';
import { SubmissionForm } from '../SubmissionForm';
import { SubmissionContextProvider } from '../SubmissionFormContext';
import { atolUser } from '../../services/interfaces';
import UserProfileForm from '../UserProfileForm';
import { ChangePassword } from '../ChangePassword';
//export class NavMenu extends Component {
interface NavMenuProps {
  toggleNav: () => void;
}

export function AdminHeader({ toggleNav }: NavMenuProps){
  const userContext = useContext(UserContext);
  const pageContext=useContext(PageContext);
  const [userQueries, setUserQueries] = useState([]);
  const [showDeleteQueryConfirm, setShowDeleteQueryConfirm]=useState(false);
  const [selectedQuery, setSelectedQuery] = useState("")
  const [submitVisible, setSubmitVisible]=useState(false);
  const [impersonateVisible, setImpersonateVisible]=useState(false);
  const [submitTitle, setSubmitTitle]=useState("Submit");
  const [submitType,setSubmitType] =useState("SB");
  const [newAdItems, setNewAdItems] = useState<string[]>([]);
  const [showMyProfile, setShowMyProfile]= useState(false);
  const [impersonateUser, setImpersonateUser]=useState("");
  const [showChangePW,setShowChangePW]=useState(false);

  const toggleUserQueries=()=>{
    pageContext?.setShowMyQueries(!pageContext.showMyQueries);
  }

  const showImpersonate=()=>{
    setImpersonateVisible(true);
  }

   const hideImpersonate=()=>{
    setImpersonateVisible(false);
  }

  const toggleNotifications=()=>{
    pageContext?.setShowNotifications(!pageContext.showNotifications);
  }

  const hideMyProfile=()=>{
    setShowMyProfile(false);
  }

  const showEditProfile=()=>{
    setShowMyProfile(true);
  }

  const setImpUser=(e:InputChangeEvent)=>{
      setImpersonateUser(e.value);
  }

  const openChangePW =()=>{
    setShowChangePW(true);
  }
  const closeChangePW =()=>{
    setShowChangePW(false);
  }

  const impersonate= async ()=>{
    var userName = impersonateUser;
    console.log(impersonateUser);
    const url = "/api/Impersonate?username="+userName;
    //console.log(url);
    try{
      const response = await fetch(url,{
        headers:{
        },
        method:"GET"
      });
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }else{            
        window.location.reload();
      }
    }
    catch(error){
        if (error instanceof Error) {
            console.error(error.message);
          } else {
            console.error('An unknown error occurred');
          }
      return false;
    }
  }

  
  const deleteQuery=()=>{
    console.log("Delete query " + selectedQuery);
    if (selectedQuery!=""){
      deleteUserQuery(selectedQuery).then(
        ()=>getSavedQueries().then(
          data => {
            setUserQueries(data);
            setSelectedQuery("");
          }
        )
      )
    }
    hideDeleteQueryWarning();
  }

  const showDeleteQueryWarning=(queryNum:string)=>{
    setSelectedQuery(queryNum);
    setShowDeleteQueryConfirm(true);
  }
  const hideDeleteQueryWarning=()=>{
    setShowDeleteQueryConfirm(false);
  }

  const backToATOL=()=>{
    window.location.replace("/");
  }

  const queryCriteriaRender = (props: GridCellProps) => {
    var retval = "";
    //console.log(props.dataItem);

    if (props.dataItem.sqL_Query_1000){
      var parseCrit = JSON.parse(props.dataItem.sqL_Query_1000);
      //console.log(parseCrit);
      for (let [key, value] of Object.entries(parseCrit)) {
        if (value != null) {
            retval += key + ": " + value + "&emsp;";
        }
      }
    }
    
    return (
      <td>
       {parse(retval)};
      </td>
    );
  }

  const queryButtons = (props: GridCellProps) => {
          return (
              <td>
                  <ButtonGroup>
                    <Button fillMode={"flat"}><FontAwesomeIcon icon={faShare}></FontAwesomeIcon></Button>
                    <Button fillMode={"flat"} onClick={() => showDeleteQueryWarning(props.dataItem.query_Num)}><FontAwesomeIcon icon={faTrash}></FontAwesomeIcon></Button>
                    <Button fillMode={"flat"}><FontAwesomeIcon icon={faGlobe}></FontAwesomeIcon></Button>                  
                  </ButtonGroup>
              </td>
          );
      }
  
  const handButtonClick = (event: any) => {
    //console.log('Item Clicked', event.item);
    switch (event.item){
      case "Log Out":
        document.cookie = "access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace(window.location.origin + "/Login");
        break;
      case "My Queries":
        getSavedQueries().then(data => {
          setUserQueries(data);
          pageContext?.setShowMyQueries(true);
        });
        break;
      case "New Ad":
        setSubmitType("NO");
        setSubmitTitle("New Ad Order");
        setSubmitVisible(true);
        break;
      case "New Spec Ad":
        setSubmitType("SP");
        setSubmitTitle("New Spec Ad Order");
        setSubmitVisible(true);
          break;
      case "New Sourcing Order":
        setSubmitType("OS");
        setSubmitTitle("New Sourcing Order");
        setSubmitVisible(true);
        break;   
      case "Edit Profile":
        setShowMyProfile(true);
        break;
      case "Reset Password":
        openChangePW();
        break;
      case "Impersonate User":
        showImpersonate();
        break;    
    }
  }
  const openHelp=()=>{
    const helpLink = pageContext?.glSettings.HelpLink;
    window.open(helpLink);
  }
  const openWhatsNew=()=>{
    const newLink = pageContext?.glSettings.WhatsNewLink;
    window.open(newLink);
  }

  const getUserProfile=()=>{
    console.log(userContext?.user);
    var trusted=0;
    if (userContext?.user.trusted){
      trusted=1;
    }
    const myProfile:atolUser = {
      fullName:userContext?.user.fullName||"",
      customer:userContext?.user.customer||"",
      email:userContext?.user.email||"",
      phone:userContext?.user.phone||"",
      fax:userContext?.user.fax||"",
      userName:userContext?.user.username||"",
      password:"",
      rep_id:0,
      security:userContext?.user.type||0,
      temp1:"",
      temp2:"",
      temp3:"",
      temp4:"",
      temp5:"",
      temp6:"",
      temp7:"",
      salt:0,
      apiKey:"",
      proof_email:false,
      insert_email:false,
      submit_email:false,
      correction_email:false,
      approval_email:false,
      associations:"",
      trusted:trusted,
      superUser:false
    };
    return myProfile;
  }

  const getAdminItems=()=>{
    var userType:number = userContext?.user.type||0;
    //console.log(userType);
    if (userType==1 || userType==2){
        if (pageContext?.uiFeatures.manageUsers==true){
          return (
            <DropDownButton text="Admin"
              iconClass='fa fa-gear'
              items={["Manage Users"]}
              fillMode={'flat'}
              onItemClick={handButtonClick}
            />
          );
        }else{
          return null;
        }
    }
    if (userType==4){
        if (pageContext?.uiFeatures.manageUsers==true){
          if (userContext?.user.trafficUser==false){
            return (
              <DropDownButton text="Admin"
                iconClass='fa fa-gear'
                items={["Manage Users"]}
                fillMode={'flat'}
                onItemClick={handButtonClick}
              />
            );
          }
        }else{
          return null;
        }
    }
    if (userType==5){
      if (userContext?.user.superUser===true){
        return (
          <DropDownButton text="Admin"
            iconClass='fa fa-gear'
            items={["Manage Users","Configure AdTracker","Impersonate User"]}
            fillMode={'flat'}
            onItemClick={handButtonClick}
          />
        )
      }else{
        return (
          <DropDownButton text="Admin"
            iconClass='fa fa-gear'
            items={["Manage Users","Configure AdTracker","Impersonate User"]}
            fillMode={'flat'}
            onItemClick={handButtonClick}
          />
        )
      }
    }
  }
  
  const notificationCount=useRef(0);
  
  useEffect(()=>{

    if (pageContext?.notifications && pageContext.notifications.length>0){
      const unread = pageContext.notifications.filter((item) => Number(item.state) === 0).length;
      notificationCount.current=unread;
    }

  },[pageContext?.notifications])
  return(
    <header>
      <AppBar>
        {userContext?.user.loggedIn?
          <>          
          <AppBarSection>
          <h4>AdTracker:Online&trade; Administrator Console</h4>
          </AppBarSection>
          
          <AppBarSpacer/>
          <AppBarSection>
            <Button fillMode={"flat"} type="button" onClick={backToATOL}>
                <FontAwesomeIcon icon={faCaretLeft}></FontAwesomeIcon> Back to ATOL
            </Button>
            <Button fillMode='flat' type="button" onClick={toggleNotifications}>
                <FontAwesomeIcon icon={faBell}></FontAwesomeIcon>
                {notificationCount.current>0?
                <BadgeContainer>
                  <Badge
                    className='navBadge'
                    rounded="full"
                    themeColor='info'
                    size='small'
                    position='inside'
                  >{notificationCount.current}</Badge>
                </BadgeContainer>
                :null}
              </Button>
              <Button fillMode={"flat"} type="button" onClick={openHelp}>
                <FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>
              </Button>
              <Button fillMode={"flat"} type="button" onClick={openWhatsNew}>
                <FontAwesomeIcon icon={faBullhorn}></FontAwesomeIcon>
              </Button>
          </AppBarSection>
          <span className='k-appbar-separator' />
          
          <AppBarSection>
            <DropDownButton fillMode={"flat"}
              text={userContext.user.username}
              items={[userContext.user.username, "My Queries", "Edit Profile", "Reset Password", "Log Out"]}
              iconClass='fa fa-user'
              onItemClick={handButtonClick}
            >
            </DropDownButton>
          </AppBarSection>
          </>
        :null}
      </AppBar>
      {pageContext?.showMyQueries?
        <Dialog
          title={"My Saved Queries"}
          onClose={toggleUserQueries}
          width={"50%"}
        >
          <Grid
            data={userQueries}
            style={{maxHeight:"400px"}}
            fixedScroll={true}
          >
            <Column
              field='query_Num'
              title='&nbsp;'
              cells={{data:queryButtons}}
              width={125}
            />
            <Column 
              field='query_Name'
              title='Query name'
            />
            <Column 
              field='sqL_Query_1000'
              title='Criteria'
              cells={{data:queryCriteriaRender}}
            />      

          </Grid>
          
        </Dialog>
      :null}
      {showChangePW?<ChangePassword onClose={closeChangePW} username={userContext?.user.username ?? ""}></ChangePassword>:null}
         
    </header>
  
    
  );
}
